import React from "react";
import PropTypes from 'prop-types';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import ReactHtmlParser from 'react-html-parser';

import { setTabsNextAndPrevButtons, goToTop, setCursorWaiting, hideCmsHiddenBlock, getLoading} from '../../../utils'

import SummaryCalculator from '../../../Helpers/summarycalculator';
import { SummaryConstants as Constants } from '../../../Helpers/summaryconstants';
import GTMHelper from '../../../Helpers/gtmHelper';
import NavHelper from '../../../Helpers/navhelper';

import Button from '../../1_Atoms/Button/Button';
import { TabsMenu } from "../../2_Molecules/Tabs/TabsMenu";
import AccessoryCard from '../../2_Molecules/AccessoryCard/AccessoryCard'
import CollapseLegal from '../../2_Molecules/Collapse/CollapseLegal';
import { Nav } from '../../3_Organisms/Nav/Nav';
import { Pricing } from '../../3_Organisms/Pricing/Pricing';
import { Modal } from '../../3_Organisms/Modal/Modal';
import { PreOrderModal } from '../../3_Organisms/Modal/PreOrderModal';
import { Alert } from '../../3_Organisms/Alert/Alert';

export const AccessoriesList = ({ HandleSelectedAccessory, ...props }) => {
    const summaryCalculator = window.summaryCalculator;
    const [nav, setNav] = React.useState(null);
    const { year, carline, trim, model, packageCode } = useParams();
    const navigate = useNavigate();
    const leftArrowRef = React.useRef();
    const rightArrowRef = React.useRef();
    const tabsContainerRef = React.useRef();
    const tabsRef = React.useRef();
    const [visibleLeftArrow, setVisibleLeftArrow] = React.useState(false);
    const [visibleRightArrow, setVisibleRightArrow] = React.useState(false);
    const legalContent = JSON.parse(sessionStorage.getItem(Constants.LegalAccessories));
    const [legalModalOpen, setLegalModalOpen] = React.useState(false);
    const { t, i18n } = useTranslation(['accessories', 'general']);
    const [accessories, setAccessories] = React.useState(null);
    const [categories, setCategories] = React.useState(null);
    const [selectedAccessories, setSelectedAccessories] = React.useState(summaryCalculator.SelectedAccessories);
    const [selectedCategory, setSelectedCategory] = React.useState(summaryCalculator.SelectedCategory);
    const [showFinancePrice, setShowFinancePrice] = React.useState(summaryCalculator.ShowFinancePrice);

    const [preorderOpen, setPreorderModalOpen] = React.useState(false);

	const gtmHelper = new GTMHelper();
	const navHelper = new NavHelper();

    hideCmsHiddenBlock();
    
    function handleArrowLeftClick(e) {
        e.preventDefault();
        tabsRef.current.scroll(tabsRef.current.scrollLeft - 50, 0);
        setTabsNextAndPrevButtons();
    }

    function handleArrowRightClick(e) {
        e.preventDefault();
        tabsRef.current.scroll(tabsRef.current.scrollLeft + 50, 0);
        setTabsNextAndPrevButtons();
    }

    function setTabsNextAndPrevButtons() {
        if (tabsRef?.current?.offsetWidth < tabsRef?.current?.scrollWidth) {
            if (tabsRef.current.scrollLeft === 0 && !((tabsRef.current.scrollWidth - tabsRef.current.clientWidth) == tabsRef.current.scrollLeft)) {
                setVisibleRightArrow(true);
                setVisibleLeftArrow(false);
            } else if ((tabsRef.current.scrollWidth - tabsRef.current.clientWidth) == tabsRef.current.scrollLeft) {
                setVisibleRightArrow(false);
                setVisibleLeftArrow(true);
            } else {
                setVisibleRightArrow(true);
                setVisibleLeftArrow(true);
            }
        } else {
            setVisibleRightArrow(false);
            setVisibleLeftArrow(false);
        }
        return;
    }

    function handleArrowLeftClick(e) {
        e.preventDefault();
        tabsRef.current.scroll(tabsRef.current.scrollLeft - 50, 0);
        setTabsNextAndPrevButtons();
    }

    function handleArrowRightClick(e) {
        e.preventDefault();
        tabsRef.current.scroll(tabsRef.current.scrollLeft + 50, 0);
        setTabsNextAndPrevButtons();
    }

	//sort popular to first item
	function isPopular(a, b){
		const bandA = a.toUpperCase();
		const bandB = b.toUpperCase();

		let comparison = 0;
		if (bandA === 'POPULAR') {
			comparison = -1;
		} else if(bandA > bandB){
			comparison = 1;
		} else if(bandA < bandB){
			comparison = -1;
		}
		return comparison;
    }

    summaryCalculator.CurrentStep = 6;

    React.useEffect(async () => {
        if (!summaryCalculator.isDataLoaded()) {
            await summaryCalculator.loadVehicleData(year, carline, trim, model, packageCode);

            setNav(null);
        } else if (summaryCalculator.Categories === null) {
            summaryCalculator.Categories = Object.keys(summaryCalculator.Accessories.data).sort(isPopular);

            setCategories(summaryCalculator.Categories);
        } else if (summaryCalculator.SelectedCategory === null) {
            summaryCalculator.SelectedCategory = "Popular";

            setSelectedCategory(summaryCalculator.SelectedCategory);
        } else if (nav === null) {
            const toRender = navHelper.getNavContent(t);
            setNav(toRender);            
            //setNav(navHelper.getNavContent(year, carline, trim, model, packageCode, summaryCalculator.CurrentStep, t));

            if (tabsRef.current) {
                tabsRef.current.removeEventListener('scroll', setTabsNextAndPrevButtons);
                tabsRef.current.addEventListener('scroll', setTabsNextAndPrevButtons, true);
                window.removeEventListener('resize', setTabsNextAndPrevButtons);
                window.addEventListener('resize', setTabsNextAndPrevButtons);

                setTabsNextAndPrevButtons();
            }        
        }

        // Force first redraw
        if (accessories === null)
        {
            setAccessories(summaryCalculator.Accessories);
        }

    }, [summaryCalculator, selectedAccessories, selectedCategory, accessories, categories]);

    async function handleSelectedAccessory(index) {
        setCursorWaiting(true);

        if (summaryCalculator.SelectedAccessories.findIndex(obj => obj.index === index) === -1) {
            const accessory = summaryCalculator.Accessories.rawData[index][1];

            let selectedAccessories = summaryCalculator.SelectedAccessories;
            selectedAccessories.push(accessory);

            await summaryCalculator.setSelectedAccessories(selectedAccessories);
        } else {
            await summaryCalculator.setSelectedAccessories(summaryCalculator.SelectedAccessories.filter((value) => value.index != index));
        }

        // Force update, this is a hack!
        setSelectedAccessories( Math.random() ); //setSelectedAccessories(summaryCalculator.SelectedAccessories);

        setCursorWaiting(false);
    }

    function nextStep() {
        goToTop();
        //navigate(`/${year}/${carline}/${trim}/${model}/${packageCode}/protections${decodeURI(window.location.search)}`);
        navigate(`/${year}/${carline}/${trim}/${model}/${packageCode}/payments${decodeURI(window.location.search)}`);
    }

    function handleShowFinanceClick(value) {
        setShowFinancePrice(value);
    }

    function hasAlertBar() {
        return summaryCalculator?._selectedModelYear?.incentives_banner || summaryCalculator?._selectedTrim?.incentives_banner;
    }

    return (
        <>
            {getLoading(false, t)}
            <Nav nav={nav} />
            <div className={`${hasAlertBar() ? 'mz-top-nav-spacing' : ''}`}>
            <Alert />

                <div className={`accessories-list ${hasAlertBar() ? '' : 'mz-top-nav-spacing'}`}>
                    {summaryCalculator.Accessories && summaryCalculator.Accessories.title ? <h5 className={`accessories-list__title ${hasAlertBar() ? 'no-top-margin' : ''}`}>{ReactHtmlParser(summaryCalculator.VehicleTitle)} {t("accessories:title")}</h5> : null}
                    {summaryCalculator.Accessories && summaryCalculator.Accessories.data && Object.keys(summaryCalculator.Accessories.data).length !== 0 ? <><br/><div><p className="mz-flex-2 caption text--grey text--center">{ReactHtmlParser(t("accessories:titleLegal"))}</p></div></> : null}
                    {
                        (summaryCalculator.Categories && summaryCalculator.SelectedCategory) && (
                            <TabsMenu
                                className="mz-bg--off-white"
                                menus={summaryCalculator.Categories.map((category, key) => ({
                                    id: key,
                                    isactive: category === summaryCalculator.SelectedCategory ? 'true': '',
                                    label: category,
                                    onClick: async () => {
                                        await summaryCalculator.setSelectedCategory(summaryCalculator.Categories[key]);
                                        setSelectedCategory(summaryCalculator.Categories[key]);

                                        gtmHelper.setGTM({'action':'Tab Click', 'accessory tab': summaryCalculator.Categories[key]}, true , false);
                                    }
                                }))}
                            />
                        )
                    
                    }
                    <div className='accessories-list__tab-content'>
                        {summaryCalculator.Accessories && summaryCalculator.Accessories.data ?.All && summaryCalculator.SelectedCategory ?
                            summaryCalculator.Accessories.data[summaryCalculator.SelectedCategory].map((accessory, key) =>
                                <AccessoryCard Accessory={accessory} Selected={summaryCalculator.SelectedAccessories ? summaryCalculator.SelectedAccessories.findIndex(obj => obj.index === accessory.index) !== -1 : ''} HandleSelectedAccessory={handleSelectedAccessory} key={key} isPopular={summaryCalculator.SelectedCategory === 'Popular' ? true : false} showFinancePrice={showFinancePrice}></AccessoryCard>)
                            : null}
                    </div>
                    {summaryCalculator.Accessories && summaryCalculator.Accessories.data && Object.keys(summaryCalculator.Accessories.data).length === 0 ? <p className="accessories-list__not-found">{t("accessories:no_accessorie_found")}</p> : null}
                    <div className="mz-legal mz-mobile">
                        <Button
                            className="mz-btn mz-btn--legal text--grey"
                            label={t("general:legal")}
                            backgroundColor="grey"
                            colour="grey"
                            icon={true}
                            iconAfter={true}
                            svg_className=""
                            svg_list="plus"
                            size={0.6}
                            onClick={() => {
                                document.querySelector('body').classList.add('disabled');
                                setLegalModalOpen(true)
                            }}
                        />
                    </div>
                </div>
            </div>

            <Pricing builtLabel={t("general:price_as_built")} builtPrice="$" loanLabel={t("general:loan_label")} loanPrice="$" /*optionsRoute={`/${year}/${carline}/${trim}/${model}/${packageCode}/payments${decodeURI(window.location.search)}`} optionsLabel="See options"*/ saveLabel={t("general:save_build")}
                leaseLabel={t("general:show_lease_price")} financeLabel={t("general:show_finance_price")} buttonLabel={t("general:next_payments")} summaryCalculator={summaryCalculator}
                HandleNextClick={nextStep} setLegalModalOpen={setLegalModalOpen} HandleShowFinanceClick={handleShowFinanceClick} setPreorderModalOpen={setPreorderModalOpen}  />
            <Modal modalContent={legalContent} isOpen={legalModalOpen} handleClose={setLegalModalOpen} modalId='legalModal' />
            <PreOrderModal isOpen={preorderOpen} handleClose={setPreorderModalOpen}></PreOrderModal> 
        </>
    )
}


export default AccessoriesList;

AccessoriesList.propTypes = {
    HandleSelectedAccessory: PropTypes.func,
}

AccessoriesList.defaultProps = {
    HandleSelectedAccessory: () => { },
};